import React from 'react'
import Welcome from '../Welcome/Welcome'

export default function Properties() {
  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
    };

    
  return (
    <div>
        <Welcome />
    </div>
  )
}
